import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PatientChatTab, CouplePatientChatTab, GroupPatientChatTab } from "../../../../patient";
import { getPatient, getCouplePatient, getGroupPatient } from "../../../application/sessionPatients";
import type { Patient, CouplePatient, GroupPatient } from "../../../../patient";

interface SessionAIChatPanelProps {
  patientId?: string;
  couplePatientId?: string;
  groupPatientId?: string;
}

export default function SessionAIChatPanel({ patientId, couplePatientId, groupPatientId }: SessionAIChatPanelProps) {
  const { t } = useTranslation();
  const [patient, setPatient] = useState<Patient | null>(null);
  const [couplePatient, setCouplePatient] = useState<CouplePatient | null>(null);
  const [group, setGroup] = useState<GroupPatient | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setPatient(null);
    setCouplePatient(null);
    setGroup(null);
    setError(false);

    if (groupPatientId) {
      getGroupPatient(groupPatientId)
        .then(data => setGroup(data))
        .catch(() => setError(true));
    } else if (couplePatientId) {
      getCouplePatient(couplePatientId)
        .then(data => setCouplePatient(data))
        .catch(() => setError(true));
    } else if (patientId) {
      getPatient(patientId)
        .then(data => setPatient(data))
        .catch(() => setError(true));
    }
  }, [patientId, couplePatientId, groupPatientId]);

  if (error) {
    return (
      <p className="text-sm text-center text-content-tertiary mt-8">
        {t('patient.chat.error')}
      </p>
    );
  }

  if (groupPatientId) {
    return group ? (
      <GroupPatientChatTab group={group} />
    ) : (
      <p className="text-sm text-center text-content-tertiary animate-pulse mt-8">
        {t('common.loading')}
      </p>
    );
  }

  if (couplePatientId && !couplePatient) {
    return (
      <p className="text-sm text-center text-content-tertiary animate-pulse mt-8">
        {t('common.loading')}
      </p>
    );
  }

  if (!couplePatientId && !patient) {
    return (
      <p className="text-sm text-center text-content-tertiary animate-pulse mt-8">
        {t('common.loading')}
      </p>
    );
  }

  if (couplePatient) {
    return <CouplePatientChatTab couplePatient={couplePatient} />;
  }

  return <PatientChatTab patient={patient!} />;
}
